import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchPromotionItems = createAsyncThunk(
  "promotionItems/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/api/promotion-items/");
      if (!response.data?.success) {
        return thunkAPI.rejectWithValue(
          response.data?.message || "Failed to load promotions"
        );
      }
      return { rows: response.data.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const promotionItemsSlice = createSlice({
  name: "promotionItems",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromotionItems.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPromotionItems.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchPromotionItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Unexpected error";
      });
  },
});

export default promotionItemsSlice.reducer;
export const selectPromotionItemsRows = (state) => state.promotionItems.rows;
export const selectPromotionItemsStatus = (state) =>
  state.promotionItems.status;
